import React from "react";

import { StyledButton, StyledButtonProps } from "./styled";

export type ButtonProps = {
  className?: string;
  id?: string;
  label: string;
  type?: "button" | "submit" | undefined;
  name?: string;
  onClickHandler?: React.FormEventHandler<HTMLButtonElement>;
  disabled?: boolean;
} & StyledButtonProps;

export const Button: React.FC<ButtonProps> = ({
  id,
  label,
  onClickHandler,
  type,
  name,
  children,
  ...rest
}) => (
  <StyledButton
    id={id}
    onClick={onClickHandler}
    type={type}
    name={name}
    {...rest}
  >
    {children}
    {label}
  </StyledButton>
);
